import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=1aa5a1ca&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=1aa5a1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5a1ca",
  null
  
)

export default component.exports